import { render, staticRenderFns } from "./setment.vue?vue&type=template&id=5f2100aa&scoped=true&"
import script from "./setment.vue?vue&type=script&lang=js&"
export * from "./setment.vue?vue&type=script&lang=js&"
import style0 from "./setment.vue?vue&type=style&index=0&id=5f2100aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2100aa",
  null
  
)

export default component.exports